module.exports = __webpack_public_path__ + "static/img/profile_h.432d61f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/customization/GlobalBPOCore/assets/profile_h.jpg
// module id = mMj6
// module chunks = 0